import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { ArrowRight, PenTool, Monitor, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheDigitalAtelier() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll();
  const {
    ref: contentRef1,
    isVisible: contentVisible1
  } = useRevealOnScroll();
  const {
    ref: imageRef1,
    isVisible: imageVisible1
  } = useRevealOnScroll();
  const {
    ref: contentRef2,
    isVisible: contentVisible2
  } = useRevealOnScroll();
  const {
    ref: imageRef2,
    isVisible: imageVisible2
  } = useRevealOnScroll();
  const {
    ref: authorityRef,
    isVisible: authorityVisible
  } = useRevealOnScroll();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll();
  return <section data-section-id="46947" id="built-by-pros-for-pros" className="dark bg-background text-foreground py-24 md:py-32 px-6 relative overflow-hidden radiating-pattern">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-32 bg-gradient-to-b from-transparent to-border opacity-20" />
      
      <div className="max-w-3xl mx-auto relative z-10">
        {}
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <span className="text-primary tracking-widest text-xs uppercase font-bold mb-4 block">
            Est. Gloucester, UK
          </span>
          <h1 className="h1 text-5xl md:text-7xl lg:text-8xl text-primary mb-6 leading-[0.9] uppercase tracking-tighter">Built for local business Pros</h1>
          <p className="text-xl md:text-2xl text-muted-foreground font-sans italic leading-relaxed">
            Because quoting shouldn't start after 8:00 PM.
          </p>
        </div>

        <Separator className="mb-16 opacity-20 bg-border" />

        {}
        <div ref={contentRef1} className={`prose prose-invert prose-lg max-w-none mb-16 transition-all duration-1000 delay-200 ease-out ${contentVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="text-lg md:text-xl leading-[1.8] text-muted-foreground first-letter:text-6xl first-letter:font-sans first-letter:text-primary first-letter:mr-3 first-letter:float-left first-letter:font-bold">
            We are Think Local SEO, based at 1 Spa Road in the heart of Gloucester. We didn't start in a glass office with beanbags and espresso machines; we started with a mission to help local tradespeople reclaim their time and dominate their local markets.
          </p>
          <p className="text-lg md:text-xl leading-[1.8] text-muted-foreground mt-6">
            Our mission is simple: to provide UK trades with the same high-tier digital tools used by big corporations, but with the 'home-turf' advantage of a local partner who knows the Gloucester, Cheltenham, and Stroud areas inside out. Whether it's recovering missed calls or climbing the Google Maps rankings, we're here to ensure your business never sleeps, even when you do.
          </p>
          <p className="text-lg md:text-xl leading-[1.8] text-muted-foreground mt-6">
            Based in Gloucester. We’re not a faceless call centre; we’re your local growth partners.
          </p>
        </div>

        {}
        <div ref={imageRef1} className={`mb-20 transition-all duration-1000 delay-300 ease-out ${imageVisible1 ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          <figure className="relative group">
            <div className="absolute inset-0 bg-primary/5 mix-blend-overlay z-10 pointer-events-none" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/uk_founders_brick_site_professional_no_brand.png" alt="Founders of ThinkLocalPro, professional UK tradespeople on a UK-style brick house site" className="w-full h-auto shadow-2xl border border-white/10 grayscale group-hover:grayscale-0 transition-all duration-700" />
            <figcaption className="mt-4 text-xs text-center text-primary tracking-widest uppercase font-bold">
              Founding Members • Gloucester HQ
            </figcaption>
          </figure>
        </div>

        {}
        <div ref={contentRef2} className={`grid grid-cols-1 md:grid-cols-[1fr_auto] gap-12 items-start mb-20 transition-all duration-1000 ease-out ${contentVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="space-y-6">
            <h2 className="h2 text-3xl md:text-4xl text-primary uppercase tracking-tight">The Advantage</h2>
            <p className="text-lg leading-[1.8] text-muted-foreground">
              The system that sends an instant WhatsApp to your missed calls.
            </p>
            <p className="text-lg leading-[1.8] text-muted-foreground">
              From automated WhatsApp recovery to dominating the local map rankings, our process is built for the reality of the UK trade industry. We're helping firms in Gloucestershire and across the UK reclaim their time and their reputation.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 pt-4">
              <div className="flex items-center gap-3 text-sm text-primary/90 font-bold">
                <PenTool className="w-5 h-5" />
                <span>Built for Sole Traders and Trades People</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-primary/90 font-bold">
                <Monitor className="w-5 h-5" />
                <span>Admin Automation</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-primary/90 font-bold">
                <MapPin className="w-5 h-5" />
                <span>Local UK Support</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={imageRef2} className={`mb-20 relative transition-all duration-1000 delay-200 ease-out ${imageVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
           <div className="absolute -top-6 -left-6 w-24 h-24 border-t-2 border-l-2 border-primary/40 hidden md:block" />
           <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b-2 border-r-2 border-primary/40 hidden md:block" />
           
           <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/uk_tradesperson_tablet_van_gloucester_no_brand.png" alt="UK tradesperson using a tablet to manage quotes in a UK-style van" className="w-full h-auto shadow-2xl border border-white/10" />
        </div>

        <Separator className="mb-16 opacity-20 bg-border" />

        {}
        <div ref={authorityRef} className={`mb-20 transition-all duration-1000 ease-out ${authorityVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="h2 text-3xl md:text-4xl text-primary uppercase tracking-tight mb-6">
            AUTHORITY (£499)
          </h2>
          <p className="text-lg md:text-xl leading-[1.8] text-muted-foreground">
            Think Local SEO is a Gloucester-based agency with hands-on local SEO management, deep knowledge of Gloucester, Cheltenham, and Stroud markets, and a "home-turf" advantage on Google Maps.
          </p>
        </div>

        {}
        <div ref={footerRef} className={`glass-panel text-center space-y-8 transition-all duration-1000 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h3 className="h3 text-3xl md:text-5xl text-foreground uppercase tracking-tighter">
            Stop losing leads to silence.
          </h3>
          <p className="text-muted-foreground max-w-md mx-auto leading-relaxed">
            Join Think Local SEO and automate the admin tasks that keep you off the tools and away from your family.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="btn-primary min-w-[200px] h-14 text-base font-bold rounded-md">
              <Link to="/PricingPage">
                Secure Founder Spot
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-primary/30 text-primary hover:bg-primary/5 min-w-[200px] h-14 text-base font-bold rounded-md">
              <Link to="/SilentOperatorPage">
                How It Works <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </div>
          
          <div className="pt-8 text-sm text-muted-foreground space-y-1 border-t border-white/5">
            <p className="font-bold text-primary uppercase tracking-widest">Think Local SEO</p>
            <p>Official WhatsApp / Phone: 01452 941841</p>
            <p className="text-xs opacity-70">Registered Address: Ground Floor, 1 Spa Road, Gloucester, GL1 1UY</p>
          </div>
        </div>
      </div>
    </section>;
}